// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cartLinkStyles } from "@vanmeter/Overrides/Widgets/Common/CartLink";
import { fontConfig } from "@vanmeter/XDL/constants";
import { color, xScreen } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

cartLinkStyles.headerClickable = {
    clickable: {
        css: css`
            position: relative;
            ${({ hasItems }: any) => hasItems && `gap: 12px;`}

            .totalCount {
                border-radius: 50%;
                background: ${color("secondary")};
                color: ${color("primary")};
                width: 19px;
                height: 19px;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: ${fontConfig.xSmall.size}px;
                position: absolute;
                top: 16px;
                left: 29px;

                ${xScreen("lte", "md")} {
                    font-size: ${fontConfig.small.size}px;
                    width: 22px;
                    height: 22px;
                    position: static;
                }
            }
            &:hover,
            &.opened {
                .totalCount {
                    background: ${color("common.ui15")};
                    color: ${color("common.ui1")};
                }
            }
            ${xScreen("lte", "md")} {
                &:hover .totalCount {
                    background: ${color("common.ui17")};
                    color: ${color("primary")};
                }
            }
        `,
    },
};

cartLinkStyles.xngTooltip = {
    tooltipContent: {
        css: css`
            border: 1px solid ${color("common.border")};
            border-top: 0;
            box-shadow: none;
            border-radius: 0;
            width: 470px;
            max-width: 470px;
            padding: 0;
           
        `,
    },
};
